module.exports = __webpack_public_path__ + "img/loading.2e47f4b1.gif";